import React from "react";
import { useHistory, useParams } from "react-router";
import { EditGroupApi } from '../../api/editGroupApi';
import { getGroupsList } from '../../api/getGroupsList';

import HeaderTopic from "../../partials/HeaderTopic";
import FooterMenu from "../../partials/FooterMenu";
import BasicButtons from "../../partials/BasicButtons";

import styles from "./EditGroup.module.css";


function EditGroup(props) {
  const { user, league, teams, setTeams, refreshStates } = props;
  const { leagueId, groupId } = useParams();
  const history = useHistory();

  const getGroup = teams.filter((team) => team.id === parseInt(groupId, 10))[0];

  const [groupName, setGroupName] = React.useState(getGroup.name);
  const [groupSlogan, setGroupSlogan] = React.useState(getGroup.slogan);
  const [groupImage, setGroupImage] = React.useState(null);
  const [viewGroupImage, setViewGroupImage] = React.useState(
    getGroup.image
      ? getGroup.image
      : "https://images.unsplash.com/photo-1527871252447-4ce32da643c6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2389&q=80"
  );

  const handleSubmit = async () => {
    const res = await EditGroupApi(
      leagueId,
      groupId,
      groupName,
      groupSlogan,
      groupImage
    );

    if (res.status === 200) {
      const res = await getGroupsList(leagueId);
      setTeams(res);
      history.push(`/leagues/${leagueId}/teams/${groupId}`);
     } else {

     }
  };

  return (
    <>
      <HeaderTopic topic={"ליגת " + league.name} />
      <FooterMenu setActive="league" />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <form className={styles.addNewGroup}>
        <h2 className="sectionTitleSize">עריכת הקבוצה</h2>
        <input
          type="text"
          placeholder="שם הקבוצה"
          required
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
        />

        <input
          type="text"
          placeholder="סלוגן"
          value={groupSlogan}
          onChange={(e) => setGroupSlogan(e.target.value)}
        />

        <img

          src={viewGroupImage}
          className={styles.groupImage}
          alt="תמונת הקבוצה"
        />

        <input
          className="hideMe"
          type="file"
          accept="image/png, image/jpeg"
          id="groupImage"
          onChange={(e) => {
            setGroupImage(e.target.files[0]);
            setViewGroupImage(URL.createObjectURL(e.target.files[0]));
          }}
        />

        <button
          className="btnMedium"
          type="button"
          onClick={() => {
            const imgElem = document.querySelector(".hideMe");
            imgElem.click();
          }}
        >
          העלאת תמונה
        </button>

        <button className="btnLarge" type="button" onClick={handleSubmit}>
          שמירת שינויים
        </button>
      </form>
    </>
  );
}

export default EditGroup;
